
import { HttpClient, HttpHeaders, HttpResponse  } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../../_services/authentication/authentication.service';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class HttpService {
	constructor(private readonly http: HttpClient, private readonly auth: AuthenticationService) { }

	getHtml(path: string): Promise<any> {
		return this.http.get(path, { headers: this.authHeader, responseType: 'text' }).toPromise();
	}

    get<T>(path: string): Promise<T> {
		return this.http.get<T>(path, { headers: this.authHeader.set('Content-Type', 'application/json') }).toPromise();
    }

    put<T>(path: string, data?: any): Promise<T> {
		return this.http.put<T>(path, data, { headers: this.authHeader.set('Content-Type', 'application/json') }).toPromise();
    }

    patch<T>(path: string, data: any): Promise<T> {
		return this.http.patch<T>(path, data, { headers: this.authHeader.set('Content-Type', 'application/json') }).toPromise();
    }

    post<T>(path: string, data: any): Promise<T> {
		return this.http.post<T>(path, data, { headers: this.authHeader.set('Content-Type', 'application/json') }).toPromise();
    }

    delete<T>(path: string): Promise<T> {
		return this.http.delete<T>(path, { headers: this.authHeader.set('Content-Type', 'application/json')}).toPromise();
    }


	private get authHeader() {
		let headers = new HttpHeaders();
		if (this.auth.accessToken) {
			headers = headers.set('Authorization', `bearer ${this.auth.accessToken}`);
		}

		return headers;
	};


}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/core/http/http.service.ts